const languages = [
  {
    "value": "eng",
    "label": "English"
  },
  {
    "value": "abk",
    "label": "Abkhazian"
  },
  {
    "value": "ace",
    "label": "Achinese"
  },
  {
    "value": "ach",
    "label": "Acoli"
  },
  {
    "value": "ada",
    "label": "Adangme"
  },
  {
    "value": "ady",
    "label": "Adygei; Adyghe"
  },
  {
    "value": "aar",
    "label": "Afar"
  },
  {
    "value": "afh",
    "label": "Afrihili"
  },
  {
    "value": "afr",
    "label": "Afrikaans"
  },
  {
    "value": "afa",
    "label": "Afro-Asiatic languages"
  },
  {
    "value": "ain",
    "label": "Ainu"
  },
  {
    "value": "aka",
    "label": "Akan"
  },
  {
    "value": "akk",
    "label": "Akkadian"
  },
  {
    "value": "alb",
    "label": "Albanian"
  },
  {
    "value": "ale",
    "label": "Aleut"
  },
  {
    "value": "alg",
    "label": "Algonquian languages"
  },
  {
    "value": "alq",
    "label": "Algonquin"
  },
  {
    "value": "tut",
    "label": "Altaic languages"
  },
  {
    "value": "amh",
    "label": "Amharic"
  },
  {
    "value": "anp",
    "label": "Angika"
  },
  {
    "value": "apa",
    "label": "Apache languages"
  },
  {
    "value": "ara",
    "label": "Arabic"
  },
  {
    "value": "arg",
    "label": "Aragonese"
  },
  {
    "value": "qar",
    "label": "Aranés"
  },
  {
    "value": "arp",
    "label": "Arapaho"
  },
  {
    "value": "arw",
    "label": "Arawak"
  },
  {
    "value": "arm",
    "label": "Armenian"
  },
  {
    "value": "rup",
    "label": "Aromanian; Arumanian; Macedo-Romanian"
  },
  {
    "value": "art",
    "label": "Artificial languages"
  },
  {
    "value": "asm",
    "label": "Assamese"
  },
  {
    "value": "ast",
    "label": "Asturian; Bable; Leonese; Asturleonese"
  },
  {
    "value": "ath",
    "label": "Athapascan languages"
  },
  {
    "value": "atj",
    "label": "Atikamekw"
  },
  {
    "value": "aus",
    "label": "Australian languages"
  },
  {
    "value": "aav",
    "label": "Austro-Asiatic languages"
  },
  {
    "value": "map",
    "label": "Austronesian languages"
  },
  {
    "value": "ava",
    "label": "Avaric"
  },
  {
    "value": "ave",
    "label": "Avestan"
  },
  {
    "value": "awa",
    "label": "Awadhi"
  },
  {
    "value": "aym",
    "label": "Aymara"
  },
  {
    "value": "aze",
    "label": "Azerbaijani"
  },
  {
    "value": "ban",
    "label": "Balinese"
  },
  {
    "value": "bat",
    "label": "Baltic languages"
  },
  {
    "value": "bal",
    "label": "Baluchi"
  },
  {
    "value": "bam",
    "label": "Bambara"
  },
  {
    "value": "bai",
    "label": "Bamileke languages"
  },
  {
    "value": "bad",
    "label": "Banda languages"
  },
  {
    "value": "bnt",
    "label": "Bantu languages"
  },
  {
    "value": "bas",
    "label": "Basa"
  },
  {
    "value": "bak",
    "label": "Bashkir"
  },
  {
    "value": "baq",
    "label": "Basque"
  },
  {
    "value": "btk",
    "label": "Batak languages"
  },
  {
    "value": "bej",
    "label": "Beja; Bedawiyet"
  },
  {
    "value": "bel",
    "label": "Belarusian"
  },
  {
    "value": "bem",
    "label": "Bemba"
  },
  {
    "value": "ben",
    "label": "Bengali"
  },
  {
    "value": "ber",
    "label": "Berber languages"
  },
  {
    "value": "bho",
    "label": "Bhojpuri"
  },
  {
    "value": "bih",
    "label": "Bihari languages"
  },
  {
    "value": "bik",
    "label": "Bikol"
  },
  {
    "value": "bin",
    "label": "Bini; Edo"
  },
  {
    "value": "bis",
    "label": "Bislama"
  },
  {
    "value": "byn",
    "label": "Blin; Bilin"
  },
  {
    "value": "zbl",
    "label": "Blissymbols; Blissymbolics; Bliss"
  },
  {
    "value": "brx",
    "label": "Bodo (India)"
  },
  {
    "value": "bos",
    "label": "Bosnian"
  },
  {
    "value": "bra",
    "label": "Braj"
  },
  {
    "value": "bre",
    "label": "Breton"
  },
  {
    "value": "bug",
    "label": "Buginese"
  },
  {
    "value": "bul",
    "label": "Bulgarian"
  },
  {
    "value": "bum",
    "label": "Bulu (Cameroon)"
  },
  {
    "value": "bua",
    "label": "Buriat"
  },
  {
    "value": "bur",
    "label": "Burmese"
  },
  {
    "value": "cad",
    "label": "Caddo"
  },
  {
    "value": "sro",
    "label": "Campidanese"
  },
  {
    "value": "yue",
    "label": "Cantonese"
  },
  {
    "value": "cat",
    "label": "Catalan"
  },
  {
    "value": "cau",
    "label": "Caucasian languages"
  },
  {
    "value": "cay",
    "label": "Cayuga"
  },
  {
    "value": "ceb",
    "label": "Cebuano"
  },
  {
    "value": "cel",
    "label": "Celtic languages"
  },
  {
    "value": "cai",
    "label": "Central American Indian languages"
  },
  {
    "value": "tzm",
    "label": "Central Atlas Tamazight"
  },
  {
    "value": "khm",
    "label": "Central Khmer"
  },
  {
    "value": "ckb",
    "label": "Central Kurdish (Sorani)"
  },
  {
    "value": "chg",
    "label": "Chagatai"
  },
  {
    "value": "cmc",
    "label": "Chamic languages"
  },
  {
    "value": "cha",
    "label": "Chamorro"
  },
  {
    "value": "che",
    "label": "Chechen"
  },
  {
    "value": "chr",
    "label": "Cherokee"
  },
  {
    "value": "chy",
    "label": "Cheyenne"
  },
  {
    "value": "chb",
    "label": "Chibcha"
  },
  {
    "value": "nya",
    "label": "Chichewa; Chewa; Nyanja"
  },
  {
    "value": "cic",
    "label": "Chickasaw"
  },
  {
    "value": "chi",
    "label": "Chinese"
  },
  {
    "value": "chn",
    "label": "Chinook jargon"
  },
  {
    "value": "chp",
    "label": "Chipewyan; Dene Suline"
  },
  {
    "value": "cho",
    "label": "Choctaw"
  },
  {
    "value": "chu",
    "label": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic"
  },
  {
    "value": "chk",
    "label": "Chuukese (Truk)"
  },
  {
    "value": "chv",
    "label": "Chuvash"
  },
  {
    "value": "nwc",
    "label": "Classical Newari; Old Newari; Classical Nepal Bhasa"
  },
  {
    "value": "syc",
    "label": "Classical Syriac"
  },
  {
    "value": "cop",
    "label": "Coptic"
  },
  {
    "value": "cor",
    "label": "Cornish"
  },
  {
    "value": "cos",
    "label": "Corsican"
  },
  {
    "value": "cre",
    "label": "Cree"
  },
  {
    "value": "mus",
    "label": "Creek"
  },
  {
    "value": "crp",
    "label": "Creoles and pidgins"
  },
  {
    "value": "cpe",
    "label": "Creoles and pidgins, English-based"
  },
  {
    "value": "cpf",
    "label": "Creoles and pidgins, French-based"
  },
  {
    "value": "cpp",
    "label": "Creoles and pidgins, Portuguese-based"
  },
  {
    "value": "crh",
    "label": "Crimean Turkish; Crimean Tatar"
  },
  {
    "value": "hrv",
    "label": "Croatian"
  },
  {
    "value": "scr",
    "label": "Croatian"
  },
  {
    "value": "cus",
    "label": "Cushitic languages"
  },
  {
    "value": "cze",
    "label": "Czech"
  },
  {
    "value": "dak",
    "label": "Dakota"
  },
  {
    "value": "dan",
    "label": "Danish"
  },
  {
    "value": "dar",
    "label": "Dargwa"
  },
  {
    "value": "prs",
    "label": "Dari; Afghan Persian"
  },
  {
    "value": "del",
    "label": "Delaware"
  },
  {
    "value": "din",
    "label": "Dinka"
  },
  {
    "value": "div",
    "label": "Divehi; Dhivehi; Maldivian"
  },
  {
    "value": "doi",
    "label": "Dogri"
  },
  {
    "value": "dgr",
    "label": "Dogrib"
  },
  {
    "value": "dra",
    "label": "Dravidian languages"
  },
  {
    "value": "dua",
    "label": "Duala"
  },
  {
    "value": "dum",
    "label": "Dutch, Middle (ca. 1050-1350)"
  },
  {
    "value": "dut",
    "label": "Dutch; Flemish"
  },
  {
    "value": "dyu",
    "label": "Dyula"
  },
  {
    "value": "dzo",
    "label": "Dzongkha"
  },
  {
    "value": "ike",
    "label": "Eastern Canadian Inuktitut"
  },
  {
    "value": "frs",
    "label": "Eastern Frisian"
  },
  {
    "value": "efi",
    "label": "Efik"
  },
  {
    "value": "egy",
    "label": "Egyptian (Ancient)"
  },
  {
    "value": "eka",
    "label": "Ekajuk"
  },
  {
    "value": "elx",
    "label": "Elamite"
  },
  {
    "value": "egl",
    "label": "Emilian"
  },
  {
    "value": "enm",
    "label": "English, Middle (1100-1500)"
  },
  {
    "value": "ang",
    "label": "English, Old (ca. 450-1100)"
  },
  {
    "value": "myv",
    "label": "Erzya"
  },
  {
    "value": "esx",
    "label": "Eskaleut languages"
  },
  {
    "value": "epo",
    "label": "Esperanto"
  },
  {
    "value": "est",
    "label": "Estonian"
  },
  {
    "value": "gez",
    "label": "Ethiopic (Ge’ez)"
  },
  {
    "value": "ewe",
    "label": "Ewe"
  },
  {
    "value": "ewo",
    "label": "Ewondo"
  },
  {
    "value": "fan",
    "label": "Fang"
  },
  {
    "value": "fat",
    "label": "Fanti"
  },
  {
    "value": "fao",
    "label": "Faroese"
  },
  {
    "value": "fij",
    "label": "Fijian"
  },
  {
    "value": "fil",
    "label": "Filipino; Pilipino"
  },
  {
    "value": "fin",
    "label": "Finnish"
  },
  {
    "value": "fiu",
    "label": "Finno-Ugrian languages"
  },
  {
    "value": "fon",
    "label": "Fon"
  },
  {
    "value": "fre",
    "label": "French"
  },
  {
    "value": "frm",
    "label": "French, Middle (ca. 1400-1600)"
  },
  {
    "value": "fro",
    "label": "French, Old (ca. 842-1400)"
  },
  {
    "value": "fur",
    "label": "Friulian"
  },
  {
    "value": "ful",
    "label": "Fulah"
  },
  {
    "value": "gaa",
    "label": "Gã"
  },
  {
    "value": "car",
    "label": "Galibi Carib"
  },
  {
    "value": "glg",
    "label": "Galician"
  },
  {
    "value": "qgl",
    "label": "Gallo"
  },
  {
    "value": "sdn",
    "label": "Gallurese"
  },
  {
    "value": "lug",
    "label": "Ganda"
  },
  {
    "value": "grt",
    "label": "Garo"
  },
  {
    "value": "gay",
    "label": "Gayo"
  },
  {
    "value": "gba",
    "label": "Gbaya"
  },
  {
    "value": "geo",
    "label": "Georgian"
  },
  {
    "value": "ger",
    "label": "German"
  },
  {
    "value": "gmh",
    "label": "German, Middle High (ca. 1050-1500)"
  },
  {
    "value": "goh",
    "label": "German, Old High (ca. 750-1050)"
  },
  {
    "value": "gem",
    "label": "Germanic languages"
  },
  {
    "value": "gil",
    "label": "Gilbertese"
  },
  {
    "value": "git",
    "label": "Gitxsan"
  },
  {
    "value": "gon",
    "label": "Gondi"
  },
  {
    "value": "gor",
    "label": "Gorontalo"
  },
  {
    "value": "got",
    "label": "Gothic"
  },
  {
    "value": "grb",
    "label": "Grebo"
  },
  {
    "value": "grc",
    "label": "Greek, Ancient (to 1453)"
  },
  {
    "value": "gre",
    "label": "Greek, Modern (1453-)"
  },
  {
    "value": "grn",
    "label": "Guarani"
  },
  {
    "value": "nrf",
    "label": "Guernésiais, Jèrriais"
  },
  {
    "value": "guj",
    "label": "Gujarati"
  },
  {
    "value": "gwi",
    "label": "Gwich’in"
  },
  {
    "value": "hai",
    "label": "Haida"
  },
  {
    "value": "hat",
    "label": "Haitian; Haitian Creole"
  },
  {
    "value": "hau",
    "label": "Hausa"
  },
  {
    "value": "haw",
    "label": "Hawaiian"
  },
  {
    "value": "heb",
    "label": "Hebrew"
  },
  {
    "value": "her",
    "label": "Herero"
  },
  {
    "value": "hil",
    "label": "Hiligaynon"
  },
  {
    "value": "him",
    "label": "Himachali languages; Western Pahari languages"
  },
  {
    "value": "hin",
    "label": "Hindi"
  },
  {
    "value": "hmo",
    "label": "Hiri Motu"
  },
  {
    "value": "hit",
    "label": "Hittite"
  },
  {
    "value": "hmx",
    "label": "Hmong-Mien languages"
  },
  {
    "value": "hmn",
    "label": "Hmong; Mong"
  },
  {
    "value": "hop",
    "label": "Hopi"
  },
  {
    "value": "hun",
    "label": "Hungarian"
  },
  {
    "value": "hup",
    "label": "Hupa"
  },
  {
    "value": "iba",
    "label": "Iban"
  },
  {
    "value": "ice",
    "label": "Icelandic"
  },
  {
    "value": "ido",
    "label": "Ido"
  },
  {
    "value": "ibo",
    "label": "Igbo"
  },
  {
    "value": "ijo",
    "label": "Ijo languages"
  },
  {
    "value": "ilo",
    "label": "Iloko"
  },
  {
    "value": "smn",
    "label": "Inari Sami"
  },
  {
    "value": "inc",
    "label": "Indic languages"
  },
  {
    "value": "ine",
    "label": "Indo-European languages"
  },
  {
    "value": "ind",
    "label": "Indonesian"
  },
  {
    "value": "inh",
    "label": "Ingush"
  },
  {
    "value": "moe",
    "label": "Innu, Montagnais"
  },
  {
    "value": "ina",
    "label": "Interlingua (International Auxiliary Language Association)"
  },
  {
    "value": "ile",
    "label": "Interlingue; Occidental"
  },
  {
    "value": "ikt",
    "label": "Inuinnaqtun"
  },
  {
    "value": "iku",
    "label": "Inuktitut"
  },
  {
    "value": "ipk",
    "label": "Inupiaq"
  },
  {
    "value": "qiv",
    "label": "Inuvialuktun"
  },
  {
    "value": "ira",
    "label": "Iranian languages"
  },
  {
    "value": "pes",
    "label": "Iranian Persian; Parsi"
  },
  {
    "value": "gle",
    "label": "Irish"
  },
  {
    "value": "mga",
    "label": "Irish, Middle (ca. 1100-1550)"
  },
  {
    "value": "sga",
    "label": "Irish, Old (to 1100)"
  },
  {
    "value": "iro",
    "label": "Iroquoian languages"
  },
  {
    "value": "ita",
    "label": "Italian"
  },
  {
    "value": "jpn",
    "label": "Japanese"
  },
  {
    "value": "jpx",
    "label": "Japanese languages"
  },
  {
    "value": "jav",
    "label": "Javanese"
  },
  {
    "value": "jow",
    "label": "Jowulu"
  },
  {
    "value": "jrb",
    "label": "Judeo-Arabic"
  },
  {
    "value": "jpr",
    "label": "Judeo-Persian"
  },
  {
    "value": "kbd",
    "label": "Kabardian"
  },
  {
    "value": "kab",
    "label": "Kabyle"
  },
  {
    "value": "kac",
    "label": "Kachin; Jingpho"
  },
  {
    "value": "kal",
    "label": "Kalâtdlisut; Greenlandic"
  },
  {
    "value": "xal",
    "label": "Kalmyk; Oirat"
  },
  {
    "value": "kam",
    "label": "Kamba"
  },
  {
    "value": "kan",
    "label": "Kannada"
  },
  {
    "value": "kau",
    "label": "Kanuri"
  },
  {
    "value": "kaa",
    "label": "Kara-Kalpak"
  },
  {
    "value": "krc",
    "label": "Karachay-Balkar"
  },
  {
    "value": "kdr",
    "label": "Karaim"
  },
  {
    "value": "krl",
    "label": "Karelian"
  },
  {
    "value": "kar",
    "label": "Karen languages"
  },
  {
    "value": "kas",
    "label": "Kashmiri"
  },
  {
    "value": "csb",
    "label": "Kashubian"
  },
  {
    "value": "kaw",
    "label": "Kawi"
  },
  {
    "value": "kaz",
    "label": "Kazakh"
  },
  {
    "value": "kha",
    "label": "Khasi"
  },
  {
    "value": "khi",
    "label": "Khoisan languages"
  },
  {
    "value": "kho",
    "label": "Khotanese; Sakan"
  },
  {
    "value": "xuu",
    "label": "Khwedam, Kxoe"
  },
  {
    "value": "kik",
    "label": "Kikuyu; Gikuyu"
  },
  {
    "value": "kmb",
    "label": "Kimbundu"
  },
  {
    "value": "kin",
    "label": "Kinyarwanda"
  },
  {
    "value": "kir",
    "label": "Kirghiz; Kyrgyz"
  },
  {
    "value": "kqs",
    "label": "Kissi, Northern"
  },
  {
    "value": "kss",
    "label": "Kissi, Southern"
  },
  {
    "value": "tlh",
    "label": "Klingon; tlhIngan-Hol"
  },
  {
    "value": "kom",
    "label": "Komi"
  },
  {
    "value": "kon",
    "label": "Kongo"
  },
  {
    "value": "kok",
    "label": "Konkani"
  },
  {
    "value": "kor",
    "label": "Korean"
  },
  {
    "value": "kpe",
    "label": "Kpelle"
  },
  {
    "value": "kro",
    "label": "Kru languages"
  },
  {
    "value": "kua",
    "label": "Kuanyama; Kwanyama"
  },
  {
    "value": "kum",
    "label": "Kumyk"
  },
  {
    "value": "kur",
    "label": "Kurdish"
  },
  {
    "value": "kru",
    "label": "Kurukh"
  },
  {
    "value": "kos",
    "label": "Kusaiean (Caroline Islands)"
  },
  {
    "value": "kut",
    "label": "Kutenai"
  },
  {
    "value": "fkv",
    "label": "Kvensk"
  },
  {
    "value": "kwk",
    "label": "Kwakiutl"
  },
  {
    "value": "lad",
    "label": "Ladino"
  },
  {
    "value": "lah",
    "label": "Lahnda"
  },
  {
    "value": "lkt",
    "label": "Lakota"
  },
  {
    "value": "lam",
    "label": "Lamba"
  },
  {
    "value": "day",
    "label": "Land Dayak languages"
  },
  {
    "value": "lao",
    "label": "Lao"
  },
  {
    "value": "lat",
    "label": "Latin"
  },
  {
    "value": "lav",
    "label": "Latvian"
  },
  {
    "value": "qlk",
    "label": "Lemko"
  },
  {
    "value": "lez",
    "label": "Lezgian"
  },
  {
    "value": "lij",
    "label": "Ligurian"
  },
  {
    "value": "lim",
    "label": "Limbergan; Limburger; Limburgish"
  },
  {
    "value": "lin",
    "label": "Lingala"
  },
  {
    "value": "lit",
    "label": "Lithuanian"
  },
  {
    "value": "jbo",
    "label": "Lojban"
  },
  {
    "value": "lmo",
    "label": "Lombard"
  },
  {
    "value": "nds",
    "label": "Low German; Low Saxon"
  },
  {
    "value": "dsb",
    "label": "Lower Sorbian"
  },
  {
    "value": "loz",
    "label": "Lozi"
  },
  {
    "value": "lub",
    "label": "Luba-Katanga"
  },
  {
    "value": "lua",
    "label": "Luba-Lulua"
  },
  {
    "value": "lui",
    "label": "Luiseño"
  },
  {
    "value": "smj",
    "label": "Lule Sami"
  },
  {
    "value": "lun",
    "label": "Lunda"
  },
  {
    "value": "luo",
    "label": "Luo (Kenya and Tanzania)"
  },
  {
    "value": "lus",
    "label": "Lushai"
  },
  {
    "value": "ltz",
    "label": "Luxembourgish; Letzeburgesch"
  },
  {
    "value": "mac",
    "label": "Macedonian"
  },
  {
    "value": "mad",
    "label": "Madurese"
  },
  {
    "value": "mag",
    "label": "Magahi"
  },
  {
    "value": "mai",
    "label": "Maithili"
  },
  {
    "value": "mak",
    "label": "Makasar"
  },
  {
    "value": "mlg",
    "label": "Malagasy"
  },
  {
    "value": "may",
    "label": "Malay"
  },
  {
    "value": "mal",
    "label": "Malayalam"
  },
  {
    "value": "poz",
    "label": "Malayo-Polynesian languages"
  },
  {
    "value": "mlt",
    "label": "Maltese"
  },
  {
    "value": "mnc",
    "label": "Manchu"
  },
  {
    "value": "mdr",
    "label": "Mandar"
  },
  {
    "value": "cmn",
    "label": "Mandarin"
  },
  {
    "value": "man",
    "label": "Mandingo"
  },
  {
    "value": "mni",
    "label": "Manipuri"
  },
  {
    "value": "mno",
    "label": "Manobo languages"
  },
  {
    "value": "glv",
    "label": "Manx"
  },
  {
    "value": "mao",
    "label": "Maori"
  },
  {
    "value": "arn",
    "label": "Mapudungun; Mapuche"
  },
  {
    "value": "mar",
    "label": "Marathi"
  },
  {
    "value": "chm",
    "label": "Mari"
  },
  {
    "value": "mah",
    "label": "Marshallese"
  },
  {
    "value": "mwr",
    "label": "Marwari"
  },
  {
    "value": "mas",
    "label": "Masai"
  },
  {
    "value": "myn",
    "label": "Mayan languages"
  },
  {
    "value": "fit",
    "label": "Meänkieli / Tornedalen Finnish"
  },
  {
    "value": "men",
    "label": "Mende"
  },
  {
    "value": "mic",
    "label": "Mi’kmaq; Micmac"
  },
  {
    "value": "crg",
    "label": "Michif"
  },
  {
    "value": "gml",
    "label": "Middle Low German"
  },
  {
    "value": "min",
    "label": "Minangkabau"
  },
  {
    "value": "mwl",
    "label": "Mirandese"
  },
  {
    "value": "moh",
    "label": "Mohawk"
  },
  {
    "value": "mdf",
    "label": "Moksha"
  },
  {
    "value": "mol",
    "label": "Moldavian; Moldovan"
  },
  {
    "value": "mkh",
    "label": "Mon-Khmer languages"
  },
  {
    "value": "lol",
    "label": "Mongo-Nkundu"
  },
  {
    "value": "mon",
    "label": "Mongolian"
  },
  {
    "value": "cnr",
    "label": "Montenegrin"
  },
  {
    "value": "mos",
    "label": "Mooré; Mossi"
  },
  {
    "value": "crm",
    "label": "Moose Cree"
  },
  {
    "value": "mun",
    "label": "Munda languages"
  },
  {
    "value": "mwf",
    "label": "Murrinh-Patha"
  },
  {
    "value": "nqo",
    "label": "N’Ko"
  },
  {
    "value": "nah",
    "label": "Nahuatl languages"
  },
  {
    "value": "nsk",
    "label": "Naskapi"
  },
  {
    "value": "nau",
    "label": "Nauruan"
  },
  {
    "value": "nav",
    "label": "Navajo; Navaho"
  },
  {
    "value": "nde",
    "label": "Ndebele, North"
  },
  {
    "value": "nbl",
    "label": "Ndebele, South"
  },
  {
    "value": "ndo",
    "label": "Ndonga"
  },
  {
    "value": "nap",
    "label": "Neapolitan"
  },
  {
    "value": "nep",
    "label": "Nepali"
  },
  {
    "value": "qls",
    "label": "Neutral Latin American Spanish"
  },
  {
    "value": "new",
    "label": "Newari; Nepal Bhasa"
  },
  {
    "value": "nia",
    "label": "Nias"
  },
  {
    "value": "nic",
    "label": "Niger-Kordofanian languages"
  },
  {
    "value": "ssa",
    "label": "Nilo-Saharan languages"
  },
  {
    "value": "niu",
    "label": "Niuean"
  },
  {
    "value": "nog",
    "label": "Nogai"
  },
  {
    "value": "qnf",
    "label": "Norman French"
  },
  {
    "value": "nai",
    "label": "North American Indian languages"
  },
  {
    "value": "crl",
    "label": "Northern East Cree"
  },
  {
    "value": "frr",
    "label": "Northern Frisian"
  },
  {
    "value": "sme",
    "label": "Northern Sami"
  },
  {
    "value": "nor",
    "label": "Norwegian"
  },
  {
    "value": "nob",
    "label": "Norwegian Bokmål"
  },
  {
    "value": "nno",
    "label": "Norwegian Nynorsk"
  },
  {
    "value": "nub",
    "label": "Nubian languages"
  },
  {
    "value": "nym",
    "label": "Nyamwezi"
  },
  {
    "value": "nyn",
    "label": "Nyankole"
  },
  {
    "value": "nyo",
    "label": "Nyoro"
  },
  {
    "value": "nzi",
    "label": "Nzima"
  },
  {
    "value": "oci",
    "label": "Occitan (post-1500)"
  },
  {
    "value": "arc",
    "label": "Official Aramaic; Imperial Aramaic (700-300 BCE)"
  },
  {
    "value": "oji",
    "label": "Ojibwa"
  },
  {
    "value": "odt",
    "label": "Old Dutch / Old Low Franconian (ca. 400–1050)"
  },
  {
    "value": "non",
    "label": "Old Norse"
  },
  {
    "value": "peo",
    "label": "Old Persian (ca. 600-400 B.C.)"
  },
  {
    "value": "ori",
    "label": "Oriya"
  },
  {
    "value": "orm",
    "label": "Oromo"
  },
  {
    "value": "osa",
    "label": "Osage"
  },
  {
    "value": "oss",
    "label": "Ossetian; Ossetic"
  },
  {
    "value": "omq",
    "label": "Oto-Manguean languages"
  },
  {
    "value": "oto",
    "label": "Otomian languages"
  },
  {
    "value": "pal",
    "label": "Pahlavi"
  },
  {
    "value": "pau",
    "label": "Palauan"
  },
  {
    "value": "pli",
    "label": "Pali"
  },
  {
    "value": "pam",
    "label": "Pampanga; Kapampangan"
  },
  {
    "value": "pag",
    "label": "Pangasinan"
  },
  {
    "value": "pan",
    "label": "Panjabi"
  },
  {
    "value": "pap",
    "label": "Papiamento"
  },
  {
    "value": "paa",
    "label": "Papuan languages"
  },
  {
    "value": "nso",
    "label": "Pedi; Sepedi; Northern Sotho"
  },
  {
    "value": "per",
    "label": "Persian"
  },
  {
    "value": "phi",
    "label": "Philippine languages"
  },
  {
    "value": "phn",
    "label": "Phoenician"
  },
  {
    "value": "pcd",
    "label": "Picard"
  },
  {
    "value": "qsp",
    "label": "Picture Communication Symbols (PCS)"
  },
  {
    "value": "pms",
    "label": "Piedmontese"
  },
  {
    "value": "crk",
    "label": "Plains Cree"
  },
  {
    "value": "pol",
    "label": "Polish"
  },
  {
    "value": "pon",
    "label": "Ponapeian"
  },
  {
    "value": "por",
    "label": "Portuguese"
  },
  {
    "value": "pra",
    "label": "Prakrit languages"
  },
  {
    "value": "pro",
    "label": "Provençal, Old (to 1500); Occitan, Old (to 1500)"
  },
  {
    "value": "pus",
    "label": "Pushto; Pashto"
  },
  {
    "value": "que",
    "label": "Quechua"
  },
  {
    "value": "raj",
    "label": "Rajasthani"
  },
  {
    "value": "rap",
    "label": "Rapanui"
  },
  {
    "value": "rar",
    "label": "Rarotongan; Cook Islands Maori"
  },
  {
    "value": "rcf",
    "label": "Réunion Creole French"
  },
  {
    "value": "rgn",
    "label": "Romagnol"
  },
  {
    "value": "roa",
    "label": "Romance languages"
  },
  {
    "value": "rum",
    "label": "Romanian"
  },
  {
    "value": "roh",
    "label": "Romansh"
  },
  {
    "value": "rom",
    "label": "Romany"
  },
  {
    "value": "run",
    "label": "Rundi"
  },
  {
    "value": "rus",
    "label": "Russian"
  },
  {
    "value": "sal",
    "label": "Salishan languages"
  },
  {
    "value": "sam",
    "label": "Samaritan Aramaic"
  },
  {
    "value": "smi",
    "label": "Sami languages"
  },
  {
    "value": "smo",
    "label": "Samoan"
  },
  {
    "value": "sad",
    "label": "Sandawe"
  },
  {
    "value": "sag",
    "label": "Sango"
  },
  {
    "value": "san",
    "label": "Sanskrit"
  },
  {
    "value": "sat",
    "label": "Santali"
  },
  {
    "value": "srm",
    "label": "Saramaccan"
  },
  {
    "value": "srd",
    "label": "Sardinian"
  },
  {
    "value": "sas",
    "label": "Sasak"
  },
  {
    "value": "sdc",
    "label": "Sassarese"
  },
  {
    "value": "sco",
    "label": "Scots"
  },
  {
    "value": "gla",
    "label": "Scottish Gaelic"
  },
  {
    "value": "sel",
    "label": "Selkup"
  },
  {
    "value": "sem",
    "label": "Semitic languages"
  },
  {
    "value": "scc",
    "label": "Serbian"
  },
  {
    "value": "srp",
    "label": "Serbian"
  },
  {
    "value": "srr",
    "label": "Serer"
  },
  {
    "value": "ojs",
    "label": "Severn Ojibwa"
  },
  {
    "value": "shn",
    "label": "Shan"
  },
  {
    "value": "sna",
    "label": "Shona"
  },
  {
    "value": "shs",
    "label": "Shuswap"
  },
  {
    "value": "iii",
    "label": "Sichuan Yi; Nuosu"
  },
  {
    "value": "scn",
    "label": "Sicilian"
  },
  {
    "value": "sid",
    "label": "Sidamo"
  },
  {
    "value": "sgn",
    "label": "Sign languages"
  },
  {
    "value": "bla",
    "label": "Siksika"
  },
  {
    "value": "szl",
    "label": "Silesian"
  },
  {
    "value": "snd",
    "label": "Sindhi"
  },
  {
    "value": "sin",
    "label": "Sinhala; Sinhalese"
  },
  {
    "value": "zhx",
    "label": "Sinitic languages"
  },
  {
    "value": "sit",
    "label": "Sino-Tibetan languages"
  },
  {
    "value": "sio",
    "label": "Siouan languages"
  },
  {
    "value": "sms",
    "label": "Skolt Sami"
  },
  {
    "value": "den",
    "label": "Slave (Athapascan)"
  },
  {
    "value": "sla",
    "label": "Slavic languages"
  },
  {
    "value": "slo",
    "label": "Slovak"
  },
  {
    "value": "slv",
    "label": "Slovenian"
  },
  {
    "value": "sog",
    "label": "Sogdian"
  },
  {
    "value": "som",
    "label": "Somali"
  },
  {
    "value": "son",
    "label": "Songhai languages"
  },
  {
    "value": "snk",
    "label": "Soninke"
  },
  {
    "value": "wen",
    "label": "Sorbian languages"
  },
  {
    "value": "sot",
    "label": "Sotho; Sesotho"
  },
  {
    "value": "sai",
    "label": "South American Indian languages"
  },
  {
    "value": "alt",
    "label": "Southern Altai"
  },
  {
    "value": "crj",
    "label": "Southern East Cree"
  },
  {
    "value": "sma",
    "label": "Southern Sami"
  },
  {
    "value": "spa",
    "label": "Spanish"
  },
  {
    "value": "srn",
    "label": "Sranan Tongo"
  },
  {
    "value": "zgh",
    "label": "Standard Moroccan Tamazight"
  },
  {
    "value": "sto",
    "label": "Stoney"
  },
  {
    "value": "suk",
    "label": "Sukuma"
  },
  {
    "value": "sux",
    "label": "Sumerian"
  },
  {
    "value": "sun",
    "label": "Sundanese"
  },
  {
    "value": "sus",
    "label": "Susu"
  },
  {
    "value": "swa",
    "label": "Swahili"
  },
  {
    "value": "csw",
    "label": "Swampy Cree"
  },
  {
    "value": "ssw",
    "label": "Swazi; Swati"
  },
  {
    "value": "swe",
    "label": "Swedish"
  },
  {
    "value": "gsw",
    "label": "Swiss German; Alemannic; Alsatian"
  },
  {
    "value": "syr",
    "label": "Syriac"
  },
  {
    "value": "tgl",
    "label": "Tagalog"
  },
  {
    "value": "tah",
    "label": "Tahitian"
  },
  {
    "value": "tai",
    "label": "Tai languages"
  },
  {
    "value": "tgk",
    "label": "Tajik; Tajiki Persian"
  },
  {
    "value": "tmh",
    "label": "Tamashek"
  },
  {
    "value": "tam",
    "label": "Tamil"
  },
  {
    "value": "shi",
    "label": "Tashelhit; Shilha"
  },
  {
    "value": "tat",
    "label": "Tatar"
  },
  {
    "value": "tel",
    "label": "Telugu"
  },
  {
    "value": "tem",
    "label": "Temne; Time"
  },
  {
    "value": "ter",
    "label": "Terena"
  },
  {
    "value": "tet",
    "label": "Tetum"
  },
  {
    "value": "tha",
    "label": "Thai"
  },
  {
    "value": "thp",
    "label": "Thompson"
  },
  {
    "value": "tib",
    "label": "Tibetan"
  },
  {
    "value": "tig",
    "label": "Tigré"
  },
  {
    "value": "tir",
    "label": "Tigrinya"
  },
  {
    "value": "tiv",
    "label": "Tiv"
  },
  {
    "value": "tli",
    "label": "Tlingit"
  },
  {
    "value": "tpi",
    "label": "Tok Pisin"
  },
  {
    "value": "tkl",
    "label": "Tokelauan"
  },
  {
    "value": "tog",
    "label": "Tonga (Nyasa)"
  },
  {
    "value": "ton",
    "label": "Tongan"
  },
  {
    "value": "rmg",
    "label": "Traveler Norwegian"
  },
  {
    "value": "tsd",
    "label": "Tsakonian"
  },
  {
    "value": "tsi",
    "label": "Tsimshian"
  },
  {
    "value": "tso",
    "label": "Tsonga"
  },
  {
    "value": "tsn",
    "label": "Tswana"
  },
  {
    "value": "tum",
    "label": "Tumbuka"
  },
  {
    "value": "tup",
    "label": "Tupi languages"
  },
  {
    "value": "tur",
    "label": "Turkish"
  },
  {
    "value": "ota",
    "label": "Turkish, Ottoman"
  },
  {
    "value": "tuk",
    "label": "Turkmen"
  },
  {
    "value": "tvl",
    "label": "Tuvaluan"
  },
  {
    "value": "tyv",
    "label": "Tuvinian"
  },
  {
    "value": "twi",
    "label": "Twi"
  },
  {
    "value": "tzo",
    "label": "Tzotzil"
  },
  {
    "value": "udm",
    "label": "Udmurt"
  },
  {
    "value": "uga",
    "label": "Ugaritic"
  },
  {
    "value": "uig",
    "label": "Uighur; Uyghur"
  },
  {
    "value": "ukr",
    "label": "Ukrainian"
  },
  {
    "value": "umb",
    "label": "Umbundu"
  },
  {
    "value": "hsb",
    "label": "Upper Sorbian"
  },
  {
    "value": "urj",
    "label": "Uralic languages"
  },
  {
    "value": "urd",
    "label": "Urdu"
  },
  {
    "value": "uzb",
    "label": "Uzbek"
  },
  {
    "value": "vai",
    "label": "Vai"
  },
  {
    "value": "qav",
    "label": "Valencian"
  },
  {
    "value": "ven",
    "label": "Venda"
  },
  {
    "value": "vec",
    "label": "Venetian/Venetan"
  },
  {
    "value": "vie",
    "label": "Vietnamese"
  },
  {
    "value": "vol",
    "label": "Volapük"
  },
  {
    "value": "vot",
    "label": "Votic"
  },
  {
    "value": "wak",
    "label": "Wakashan languages"
  },
  {
    "value": "wls",
    "label": "Wallisian"
  },
  {
    "value": "wln",
    "label": "Walloon"
  },
  {
    "value": "war",
    "label": "Waray"
  },
  {
    "value": "was",
    "label": "Washo"
  },
  {
    "value": "guc",
    "label": "Wayuu"
  },
  {
    "value": "wel",
    "label": "Welsh"
  },
  {
    "value": "fry",
    "label": "Western Frisian"
  },
  {
    "value": "qsw",
    "label": "Widgit symbols"
  },
  {
    "value": "wal",
    "label": "Wolaitta; Wolaytta"
  },
  {
    "value": "wol",
    "label": "Wolof"
  },
  {
    "value": "cwd",
    "label": "Woods Cree"
  },
  {
    "value": "wym",
    "label": "Wymysorys"
  },
  {
    "value": "xho",
    "label": "Xhosa"
  },
  {
    "value": "sah",
    "label": "Yakut"
  },
  {
    "value": "yao",
    "label": "Yao"
  },
  {
    "value": "yap",
    "label": "Yapese"
  },
  {
    "value": "yid",
    "label": "Yiddish"
  },
  {
    "value": "yor",
    "label": "Yoruba"
  },
  {
    "value": "ypk",
    "label": "Yupik languages"
  },
  {
    "value": "znd",
    "label": "Zande languages"
  },
  {
    "value": "zap",
    "label": "Zapotec"
  },
  {
    "value": "zza",
    "label": "Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki"
  },
  {
    "value": "zen",
    "label": "Zenaga"
  },
  {
    "value": "zha",
    "label": "Zhuang; Chuang"
  },
  {
    "value": "zul",
    "label": "Zulu"
  },
  {
    "value": "zun",
    "label": "Zuni"
  },
  {
    "value": "mis",
    "label": "Uncoded language"
  },
  {
    "value": "und",
    "label": "Undetermined language"
  },
  {
    "value": "mul",
    "label": "Multiple languages"
  }
];

module.exports = { languages };